<template>
  <div class="ArticleListBox" style="    margin-top: 50px;">
    <a-row type="flex" justify="space-between">
      <a-col :span="24">
        <div class="col-md-8 " style="margin-left:20px">
          <ArticleContent
            :id="articleId"
            :title="articleTitle"
            :isShow="false"
          />
        </div>
      </a-col>
    </a-row>
    <div class="warper clearfix">
      <div class="releaseBox">
        <a-row>
          <a-col :span="2"></a-col>
          <a-col :span="18"> </a-col>
          <a-col :span="4">
            <div class="anchorBox" style="width:100%">
              <p>Update History</p>
              <a-anchor :affix="false" :target-offset="targetOffset">
                <a-anchor-link
                  v-for="(item, index) in List"
                  :key="'anchorlink' + index"
                  :href="'#anchor' + index"
                  :title="item.name | nameFilter"
                />
              </a-anchor>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleContent from "@/views/ArticleContent.vue";
import { getIspQuickGuide, queryIspArticleList } from "@/utils/query.js";

export default {
  name: "Home",
  components: {
    ArticleContent,
  },
  data() {
    return {
      Searchvalue: "",
      SearchvalueKey: "",
      openKeys: [],
      selectedKeys: [],
      replaceFields: {
        title: "name",
        key: "id",
      },
      List: [],
      breadItem: {},
      articleId: "",
      articleTitle: "",
      List: "",
      TreeNames: [], //被选中文章的父级目录们
      showArticleContent: true,
      searchList: [],
      targetOffset: window.innerHeight / 4,
    };
  },
  mounted() {
    this.getCate();
  },
  filters: {
    nameFilter(value) {
      return value.split(" ")[0];
    },
  },
  methods: {
    async getCate() {
      let res = await getIspQuickGuide();
      this.List = [];
      if (res.code === 200) {
        this.List = res.data.directoryJson;
      }
      this.articleId = this.List[0].id;

      // this.initData();
    },

    selectNode(item, firstChild = {}) {
      this.articleId = item.id || String(item.g_id).split("&")[0];
      // this.articleTitle = item.name;
      if (firstChild.id) {
        this.articleId = firstChild.id;
        // this.articleTitle = firstChild.name;
      }
      if (item.title.includes("Release Notes")) {
        this.$router.push({
          name: "releaseArticle",
          query: { id },
        });
      } else {
        this.$router.push({
          name: "ArticleList",
          query: { id: this.articleId },
        });
      }
      this.initData();
    },
    // searchListClick() {
    //   this.selectedKeys = [this.articleId];
    //   this.openKeys = getTreeIds(this.List, this.articleId);
    //   this.TreeNames = getTreeNames(this.List, this.articleId);
    //   this.sentzhugePoint();
    // },
    openChange(openKeys) {
      this.openKeys = openKeys;
    },
    async onSearch() {
      if (this.Searchvalue == "") return;
      this.showArticleContent = false;
      let res = await queryIspArticleList(this.Searchvalue);
      let { items } = res.data.result;
      if (res.success) {
        this.searchList = [...items];
      } else {
        this.searchList = [];
      }
      this.SearchvalueKey = this.Searchvalue;
      console.log("searchList", this.searchList);
    },
    async onChange() {
      this.SearchvalueKey = this.Searchvalue;
      if (this.Searchvalue == "") {
        this.searchList = [];
        return;
      }
      this.searchList = [];
      let res = await queryIspArticleList(this.Searchvalue);
      let { items } = res.data.result;
      if (res.success) {
        this.searchList = [...items];
      }
    },
    sentzhugePoint() {
      let lv01 = this.TreeNames[0];
      let lv02 = this.TreeNames[1] ? this.TreeNames[1] : "";
      let lv03 = this.TreeNames[2] ? this.TreeNames[2] : "";
      this.zhugePoint("macc-help-文档中心-模块统计", {
        userid: this.GLOBAL.userid, //用户id
        lv01, //一级目录、模块
        lv02, //二级目录
        lv03, //三级目录
      });
      console.log("macc-help-文档中心-模块统计", this.TreeNames);
    },
    goUrl(item) {
      this.$router.push({
        name: "releaseArticle",
        query: { id: item.id },
      });
    },
  },
};
</script>
<style scoped>
ul,
li,
dl,
dt,
dd,
section,
div {
  padding: 0px;
  margin: 0px;
  list-style: none;
}

p {
  font-size: 20px;
}

h3 {
  font-size: 30px;
}
body {
  padding-top: 68px;
  font-family: "\5FAE\8F6F\96C5\9ED1";
}
.warper {
  max-width: 1377px;
  margin: 0px auto;
}
.warper1 {
  max-width: 1060px;
  margin: 0px auto;
}
.logo {
  background-image: url(../../assets/images/logo.png);
  background-repeat: no-repeat;
  background-position: center;
  width: 110px;
  height: 69px;
  background-size: contain;
}

.icon-authsms {
  background-image: url(../../assets/images/extendicon/authsms.png);
}
.icon-authwechat {
  background-image: url(../../assets/images/extendicon/authwechat.png);
}
.icon-authppsk {
  background-image: url(../../assets/images/extendicon/authppsk.png);
}
.icon-cxxiaoluohao {
  background-image: url(../../assets/images/extendicon/cxxiaoluohao.png);
}
.icon-cxppsk {
  background-image: url(../../assets/images/extendicon/cxppsk.png);
}

/***************content**********************/
.ui-content .ui-content-header {
  border-bottom: 1px solid #efefef;
  line-height: 2;
}
.ui-content .ui-content-header h2 {
  margin-top: 10px;
  font-size: 20px;
  font-weight: bold;
}
.ui-content .ui-content-header .ui-content-items {
  color: #999999;
}
.ui-content .ui-content-body {
  padding: 15px;
}
.ui-content .ui-content-body img {
  width: auto !important;
  height: auto !important;
  max-width: 1400px;
}
.ui-content .ui-content-body table {
  width: 100%;
}
.ui-content .ui-content-body table th,
.ui-content .ui-content-body table td {
  border: 1px solid #ccc;
  padding: 5px;
}
.ui-content-tags {
  margin-top: 15px;
}
.ui-share-content {
  display: inline-block;
}
.ui-content-link {
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  padding: 5px 0px;
  margin-top: 15px;
}
.ui-content-link li {
  list-style: disc;
  list-style-position: inside;
  padding: 5px 0px;
}
@media screen and (max-width: 980px) {
  .ui-article-list > ul > li {
    padding: 0px 10px;
  }
  .ui-search-box {
    width: 150px;
  }
  .ui-index-body {
    padding: 0px;
  }
}

.ArticleListBox {
  padding-top: 1rem;
  /* margin-top: 68px; */
}
</style>
